import {Injectable} from "@angular/core"
import {Subject} from "rxjs"

@Injectable()
export class PreviewSceneService {
    public $refresh = new Subject<void>()
}
